import { Box, Card, CardContent, Typography } from '@mui/material';
import { Construction } from '@mui/icons-material';

// Placeholder for Staff Portal modules that are planned but not built yet
// (Imprest, Claim Requisitions, Imprest Surrenders, My Activities).
export default function StaffComingSoon({ title = 'Coming soon', blurb }) {
  return (
    <Box sx={{ maxWidth: 720, mx: 'auto', mt: { xs: 2, sm: 6 }, px: { xs: 1.5, sm: 0 } }}>
      <Card elevation={3}>
        <CardContent sx={{ textAlign: 'center', py: 6 }}>
          <Construction sx={{ fontSize: 64, color: 'primary.main', mb: 2, opacity: 0.85 }} />
          <Typography variant="h5" fontWeight={800} gutterBottom>{title}</Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 460, mx: 'auto' }}>
            {blurb || 'This self-service module is on the way. Check back soon.'}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
